import { render, staticRenderFns } from "./selectGrade.vue?vue&type=template&id=25710497&scoped=true"
import script from "./selectGrade.vue?vue&type=script&lang=js"
export * from "./selectGrade.vue?vue&type=script&lang=js"
import style0 from "./selectGrade.vue?vue&type=style&index=0&id=25710497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25710497",
  null
  
)

export default component.exports